import { FC } from 'react'
import TSvgProps from './type/svgPropsType'

const GuideIcon: FC<TSvgProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      {...props}
    >
      <desc>정보 아이콘</desc>
      <path fill="none" d="M0 0h28v28H0z" data-name="사각형 21578"></path>
      <g fill="#fff" stroke="#333" strokeWidth="1.5" data-name="그룹 29747">
        <g data-name="타원 1756" transform="translate(5 5)">
          <circle cx="9" cy="9" r="9" stroke="none"></circle>
          <circle cx="9" cy="9" r="8.25" fill="none"></circle>
        </g>
        <g
          strokeLinecap="round"
          data-name="사각형 21584"
          transform="translate(13.25 9.636)"
          fill="#333"
        >
          <rect width="1.5" height="6" stroke="none" rx="0.75"></rect>
          <rect height="4.5" x="0.75" y="0.75" fill="none"></rect>
        </g>
        <g
          data-name="타원 1757"
          transform="translate(13.25 16.976)"
          fill="#333"
        >
          <circle cx="0.75" cy="0.75" r="0.75" stroke="none"></circle>
          <circle cx="0.75" cy="0.75" fill="none"></circle>
        </g>
      </g>
    </svg>
  )
}

export default GuideIcon
